import { render, staticRenderFns } from "./StripImportArchive.vue?vue&type=template&id=5997dc1d&"
import script from "./StripImportArchive.vue?vue&type=script&lang=js&"
export * from "./StripImportArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports